import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CHECKLIST_PERMISSIONS } from 'shared';
import { RequirePermission } from '@/components/shared/RequirePermission';

export const Route = createFileRoute('/_authenticated/checklist-management')({
  component: ChecklistManagementLayout,
});

function ChecklistManagementLayout() {
  return (
    <RequirePermission permission={CHECKLIST_PERMISSIONS.READ}>
      <Outlet />
    </RequirePermission>
  );
}
